import qs from 'qs'
export const querystring = option => {
  return '?' + qs.stringify(option)
}

export const urlStringify = option => {
  return '?' + qs.stringify(option)
}

export const downloadBlobFile = res => {
  const fileName = res.headers['content-disposition']
    .split('filename')[1]
    .slice(1)
  const blob = new Blob([res.data], { type: res.headers['content-type'] })
  if (window.navigator.msSaveBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName)
    return false
  }
  const a = document.createElement('a')
  document.body.appendChild(a)
  a.download = fileName
  a.target = '_blank'
  a.href = URL.createObjectURL(blob)
  a.click()
  document.body.removeChild(a)
}

function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}
export const guid = () => {
  return (
    S4() +
    S4() +
    '-' +
    S4() +
    '-' +
    S4() +
    '-' +
    S4() +
    '-' +
    S4() +
    S4() +
    S4()
  )
}

export const ORDERTAG = [
  {
    label: '无标旗',
    value: 0
  },
  {
    label: '正常', // 红旗
    value: 1
  },
  {
    label: '拍A发B', // 黄旗
    value: 2
  },
  {
    label: '刷单', // 绿旗
    value: 3
  },
  {
    label: '蓝旗',
    value: 4
  },
  {
    label: '紫旗',
    value: 5
  }
]
export const SOURCENAME = [
  {
    label: '天猫',
    value: 1
  },
  {
    label: '京东',
    value: 2
  },
  {
    label: '小程序',
    value: 3
  },
  {
    label: '大健康事业小程序',
    value: 4
  },
  {
    label: '其他小平台',
    value: 5
  },
  {
    label: '淘宝',
    value: 6
  },
  {
    label: '礼品',
    value: 7
  },
  {
    label: '抖音',
    value: 8
  },
  {
    label: '线下',
    value: 9
  }
]

export const OrderStatusName = [
  {
    label: '正常',
    value: 0
  },
  {
    label: '部分退单',
    value: 1
  },
  {
    label: '全部退单',
    value: 2
  }
]

export const OrderOutStatusName = [
  {
    label: '未发货',
    value: 0
  },
  {
    label: '发货中',
    value: 1
  },
  {
    label: '发货完成',
    value: 2
  },
  {
    label: '挂起',
    value: 9
  }
]
export const OrderOutTypeName = [
  {
    label: '待定',
    value: 0
  },
  {
    label: '正常发货',
    value: 1
  },
  {
    label: '空包',
    value: 2
  }
  // {
  //   label: '特殊',
  //   value: 3
  // }
]

export const RefundTypeName = [
  {
    label: '退款(未发货退款)',
    value: 1
  },
  {
    label: '退款不退货',
    value: 2
  },
  {
    label: '退货',
    value: 3
  }
]
export const RefundStatusName = [
  {
    label: '申请退款',
    value: 0
  },
  {
    label: '拒绝退款',
    value: 1
  },
  {
    label: '退款关闭(取消退款)',
    value: 2
  },
  {
    label: '待退货',
    value: 3
  },
  {
    label: '待收货',
    value: 4
  },
  {
    label: '退款成功',
    value: 5
  }
]

export const CheckStatusName = [
  {
    label: '待盘点',
    value: 0
  },
  {
    label: '盘点中',
    value: 1
  },
  {
    label: '盘点完成',
    value: 2
  }
]

export const PrintStatusName = [
  {
    label: '未打印',
    value: 0
  },
  {
    label: '打印中',
    value: 1
  },
  {
    label: '打印完成',
    value: 2
  },
  {
    label: '打印失败',
    value: 9
  }
]

export const OutStatusName = [
  {
    label: '未发货', // 未出库
    value: 0
  },
  {
    label: '发货中', // 出库中
    value: 1
  },
  {
    label: '发货完成', // 出库完成
    value: 2
  },
  {
    label: '取消发货', // 取消出库
    value: 9
  }
]
export const OutTypeName = [
  {
    label: '销售出库',
    value: 21
  },
  {
    label: '盘点出库',
    value: 22
  },
  {
    label: '调拨出库',
    value: 23
  }
]
export const WarehouseTypeName = [
  {
    label: '成品',
    value: 1
  },
  {
    label: '包材',
    value: 2
  },
  {
    label: '原料',
    value: 3
  },
  {
    label: '外购成品',
    value: 9
  }
]

export const AllocateStatusName = [
  {
    label: '待提交',
    value: 0
  },
  {
    label: '待审核',
    value: 1
  },
  {
    label: '审核通过',
    value: 2
  },
  {
    label: '驳回',
    value: 3
  },
  {
    label: '部分出库',
    value: 4
  },
  {
    label: '全部出库',
    value: 5
  },
  {
    label: '部分入库',
    value: 6
  },
  {
    label: '全部入库',
    value: 7
  },
  {
    label: '调拨完成',
    value: 8
  },
  {
    label: '调拨中止',
    value: 9
  }
]

export const TransTypeName = [
  {
    label: '陆运',
    value: 1
  },
  {
    label: '空运',
    value: 2
  },
  {
    label: '自提',
    value: 3
  }
]

export const MeasureUnitName = [
  {
    label: '克',
    value: 1
  },
  {
    label: '千克',
    value: 2
  },
  {
    label: '毫升',
    value: 3
  },
  {
    label: '升',
    value: 4
  },
  {
    label: 'g',
    value: 8
  },
  {
    label: 'kg',
    value: 9
  },
  {
    label: 'ml',
    value: 10
  },
  {
    label: ' L',
    value: 11
  },
  {
    label: '件',
    value: 12
  }
]
export const PayType = [
  {
    label: '现付',
    value: 1
  },
  {
    label: '到付',
    value: 2
  },
  {
    label: '月结',
    value: 3
  },
  {
    label: '第三方支付',
    value: 4
  }
]
